<template>
  <div class="detailContainer">
    <el-timeline>
      <el-timeline-item
        v-for="(item, index) in tableData" :key="index" :timestamp="item.createTime"
        placement="top"
      >
        <el-card>
          <el-form :model="item" class="operationData">
            <!--操作ip-->
            <el-form-item
              prop="ip"
              :label="$t('basicData.OperationalIP') + '：'"
            >
              <div>{{ item.ip }}</div>
            </el-form-item>
            <!--操作人姓名-->
            <el-form-item
              prop="operatorName"
              :label="$t('basicData.OperatorName') + '：'"
            >
              <div>{{ item.operatorName }}</div>
            </el-form-item>
            <!--操作时间-->
            <el-form-item
              prop="createTime"
              :label="$t('basicData.OperationTime') + '：'"
            >
              <div>{{ item.createTime }}</div>
            </el-form-item>
            <!--操作内容-->
            <el-form-item
              prop="operationContent"
              :label="$t('basicData.ActionContent') + '：'"
            >
              <div v-for="(list, ind) in item.operationContent.split('\n')" :key="ind">
                {{ list }}
                <!--下载报价-->
                <span
                  v-if="item.extra && ind === (item.operationContent.split('\n').length - 1)"
                  style="color: #409eff;cursor: pointer;"
                  @click="downloadQuote(item.extra)"
                >{{ $t('basicData.DownloadTheQuote') }}</span>
              </div>
            </el-form-item>
          </el-form>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { apiOfferPriceOperateLog } from '@/api/finance/basicData';
import toolRequestClass from '@/views/finance/mixins/toolRequestClass';
import { downloadFile } from './downloadFile';

export default {
  name: 'OperationLog',
  mixins: [toolRequestClass],
  props: {
    // 报价列表详情
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      tableData: [],
      createUser: [],
      expenseTypeList: []
    };
  },
  watch: {
    editData: {
      handler(val) {
        console.log('editData', val);
        this.getExpenseTypeList({
          state: 1, // 启用
          attribute: 1, // 应收
          businessType: val.businessType
        });
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.createUser = getUserIdAndNameObj();
    this.getLogTable();
    this.getInsuranceType();
    this.getApiOptionForSelect();
  },
  methods: {
    // 下载报价
    downloadQuote(data) {
      const dataArr = JSON.parse(data);
      console.log('dataArr', dataArr);
      const { detailData, mainData, otherData } = dataArr;
      console.log('detailData', downloadFile);
      downloadFile(mainData, detailData, otherData, this.expenseTypeList, this.specialFeeList, this.insuranceTypeList, this.modelList);
    },
    // 获取操作日志
    getLogTable() {
      const dateData = (property, bol) => {
        return function(a, b) {
          const value1 = a[property];
          const value2 = b[property];
          if (bol) {
            // 升序
            return Date.parse(value1) - Date.parse(value2);
          } else {
            // 降序
            return Date.parse(value2) - Date.parse(value1);
          }
        };
      };
      apiOfferPriceOperateLog(this.editData.id).then(res => {
        if (res.code === 200) {
          res.data.map(item => {
            item.createTime = item.createTime.replace(/[TZ]/g, ' ');
          });
          res.data.sort(dateData('createTime', false));
          this.tableData = res.data;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.detailContainer {
  height: calc(100vh - 40px);
  overflow-y: auto;
  padding: 20px;
}
.el-timeline{
  padding: 0;
}
.el-form-item{
  margin-bottom: 0;
}
.operationData .el-form-item__label,
.operationData .el-form-item__content{
  line-height: 26px!important;
}
pre {
  white-space: pre-wrap;      /* css-3 */
  white-space: -moz-pre-wrap;  /* Mozilla, since1999 */
  white-space: -o-pre-wrap;    /*Opera 7 */
  word-wrap:break-word;       /* Internet Explorer 5.5+ */
  margin: 0;
  font-family: inherit;
  max-width: 600px;
}
</style>
